import { CircularProgress } from "@mui/material";
import Map from "@commons/Map";
import Text from "@commons/Typography/Text";
import PublicIcon from "@mui/icons-material/Public";
import type { ElementType } from "react";
import type {
  GeoJsonFeature,
  GeoJsonFeatureCollection,
} from "@typings/components/map";

interface MapViewProps<T> {
  geoJsonData?: unknown;
  popupComponent?: ElementType<{
    feature: GeoJsonFeature<T>;
    onNavigate: (path: string) => void;
  }>;
  isLoading: boolean;
  error: unknown;
}

function MapView<T>({
  geoJsonData,
  popupComponent,
  isLoading,
  error,
}: MapViewProps<T>) {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-[60vh] bg-gray-50 rounded-lg">
        <CircularProgress size={60} className="text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-[60vh] bg-gray-50 rounded-lg gap-2">
        <PublicIcon className="text-4xl text-gray-400" />
        <Text size="md" className="text-gray-400">
          Erro ao carregar dados do mapa
        </Text>
      </div>
    );
  }

  if (!geoJsonData) {
    return (
      <div className="flex flex-col items-center justify-center h-[60vh] bg-gray-50 rounded-lg gap-2">
        <PublicIcon className="text-4xl text-gray-400" />
        <Text size="md" className="text-gray-400">
          Nenhum dado disponível
        </Text>
      </div>
    );
  }

  return (
    <div className="h-[60vh] w-full rounded-lg overflow-hidden border border-gray-200 p-2 bg-white">
      <Map.Root>
        <Map.Display<T>
          geoJsonData={geoJsonData as GeoJsonFeatureCollection<T>}
          popupComponent={popupComponent}
        />
      </Map.Root>
    </div>
  );
}

export default MapView;
